import Messages from "./Messages";
import ChatInput from "./ChatInput";
import PropTypes from "prop-types";
import { Component } from "react";

class Chat extends Component {
	render() {
		return (
			<div className="container">
				<ChatInput
					addMessage={this.props.addMessage}
					disabled={this.props.disabled}
				/>
				<Messages messages={this.props.messages} />
			</div>
		);
	}
}

Chat.propTypes = {
	messages: PropTypes.array.isRequired,
	addMessage: PropTypes.func,
	disabled: PropTypes.bool,
};

export default Chat;
